import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthenticatedApi } from '../api-definition'

export const AdminApiClient = generateApiClient('user-api', AdminApi.routes)
export const AuthenticatedApiClient = generateApiClient('user-api', AuthenticatedApi.routes)
